import * as React from 'react';

import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { CompareBanner } from '../../components/CompareBanner';
import { useApplicationContext } from '../../utils/applicationContext';
import { trackCloseCompareModal, trackCompareBanner, trackScrollCompareModal, trackShowCompareModal } from './tracking';
import { SliderModalLoadable, type TSliderModalProps } from './loadable';

type TSlides = TSliderModalProps['slides'];

const SLIDES_CONFIG_KEY = 'Newbuilding.CompareFlightTrap.Slides';

export const CompareBannerContainer = () => {
  const { config } = useApplicationContext();
  const [open, setOpen] = React.useState(false);

  const slides = config.get<TSlides>(SLIDES_CONFIG_KEY) ?? [];

  const handleClickOpen = React.useCallback(() => {
    setOpen(true);
    trackCompareBanner({ action: 'click_sopr' });
  }, []);

  const handleClickClose = React.useCallback(() => {
    setOpen(false);
    trackCloseCompareModal();
  }, []);

  const handleSlideChange = React.useCallback((pageId: number) => {
    trackScrollCompareModal({ pageId });
  }, []);

  return (
    <>
      <ActionAfterViewObserver callback={() => trackCompareBanner({ action: 'show' })} triggerOnce>
        <CompareBanner onClick={handleClickOpen} />
      </ActionAfterViewObserver>

      {open && (
        <ActionAfterViewObserver callback={() => trackShowCompareModal()} triggerOnce>
          <SliderModalLoadable slides={slides} onClose={handleClickClose} onSlideChange={handleSlideChange} />
        </ActionAfterViewObserver>
      )}
    </>
  );
};
